module.exports = __webpack_public_path__ + "static/media/OR_map@2x.06b9e9b7.png";